import { Box } from "@mui/material";
import Header from "../../../components/Header";
import NetworkZones from "./zones-components/NetworkZones";

// Pagina di rete "Network Zones (IEC 62443)" — TASK-AI-031. Vista distinta
// e non correlata alla feature "Zones" manuale (name/note/risk, gestita da
// ZoneManagerDialog): qui le zone e i conduit zona-zona sono quelli
// risolti/enforced da Orion (IP/VLAN, allow-list, Security Level), non
// etichette assegnate a mano.
//
// customerName: presente solo quando montata sotto /reseller/myC/... (stessa
// distinzione reseller/user di Status/AssetsOverview) -- un reseller che
// arriva qui senza aver selezionato un cliente (URL diretto, stato stantio)
// va rimandato alla home reseller invece di vedere una pagina vuota/rotta,
// perché senza customer selezionato il device cookie non risolve a nessun
// asset del cliente giusto.
const NetworkZonesPage = ({ customerName }) => {
  if (!customerName && window.sessionStorage.getItem("type") === "reseller") {
    window.sessionStorage.setItem("selectedTab", "Dashboard");
    setTimeout(function checkCondition() {
      if (window.sessionStorage.getItem("selectedTab") === "Dashboard") {
        window.location.href = `/${window.sessionStorage.getItem("type")}/home`;
      } else {
        setTimeout(checkCondition, 500);
      }
    }, 0);
  }

  return (
    <Box m="20px">
      <Header title="Network Zones" subtitle="IEC 62443 zone conduits and Security Level gap" />
      <NetworkZones />
    </Box>
  );
};

export default NetworkZonesPage;
